import { createFileRoute } from '@tanstack/react-router';
import { EinvoicingPage } from '@/features/finance';

/** The e-invoicing mode and signing certificates (the certificate-expiry notification links here). */
export const Route = createFileRoute('/_auth/o/$orgId/finance/einvoicing')({
  component: EinvoicingRoute,
});

function EinvoicingRoute() {
  const { orgId } = Route.useParams();
  return <EinvoicingPage orgId={orgId} />;
}
